module.exports = "/_next/static/images/9b4dfc2cdf501f9857650c5692b82ba8-young-people-walking@1x.jpg.webp";